var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"container-fluid",class:{
        'tw-p-u': _vm.isTailwind,
      }},[_c('div',{class:{
          'row': !_vm.isTailwind,
        }},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }